import type { Product } from "@repo/shared-types";
import { Button } from "@repo/ui/components/button";
import { Image } from "@repo/ui/components/image";

interface ProductButtonProps {
  product: Product;
  onClick: () => void;
}

export function ProductButton({ product, onClick }: ProductButtonProps) {
  const hasImage =
    product.imageUrl !== null &&
    product.imageUrl !== undefined &&
    product.imageUrl !== "";

  if (hasImage) {
    return (
      <Button
        variant="pos-outline"
        size="4xl"
        onClick={onClick}
        className="h-full p-2"
      >
        <div className="flex flex-col h-full w-full">
          <div className="h-[80%] w-full flex items-center justify-center overflow-hidden">
            <Image
              src={product.imageUrl}
              alt={product.name}
              className="w-full h-full object-contain"
            />
          </div>
          <div className="h-[20%] w-full flex items-center justify-center text-center text-lg font-medium">
            {product.name}
          </div>
        </div>
      </Button>
    );
  }

  return (
    <Button
      className="text-4xl! font-bold!"
      variant="pos-outline"
      size="4xl"
      onClick={onClick}
    >
      {product.name}
    </Button>
  );
}
